/** 裸金属节点计费资源 code */
export const BARE_METAL_NODE_RESOURCE_CODE = 'BareMetalNode';

/** 物理节点列表默认分页 */
export const DEFAULT_NODE_LIST_PAGINATION = {
  page: 1,
  limit: 10,
  total: 0,
} as const;
